export class RegisterConstants {
  public static EMAIL_ATTRIBUTE = "email";
  public static FIRST_NAME_ATTRIBUTE = "custom:first_name";
  public static LAST_NAME_ATTRIBUTE = "custom:last_name";
  public static PHONE_NUMBER_ATTRIBUTE = "custom:phone_number";
  public static FORMATTED_ADDRESS_ATTRIBUTE = "custom:formatted_address";
  public static ADDRESS_LINE1_ATTRIBUTE = "custom:address_line1";
  public static ADDRESS_LINE2_ATTRIBUTE = "custom:address_line2";
  public static CITY_ATTRIBUTE = "custom:city";
  public static STATE_ATTRIBUTE = "custom:state";
  public static ZIP_CODE_ATTRIBUTE = "custom:zip_code";
  public static COUNTRY_ATTRIBUTE = "custom:country";
  public static LATITUDE_ATTRIBUTE = "custom:latitude";
  public static LONGITUDE_ATTRIBUTE = "custom:longitude";
  public static ROLE_TYPE_ATTRIBUTE = "custom:custom_role_type";
  public static FACILITY_TYPE_ATTRIBUTE = "custom:facility_type";
}

export const ROLE_TYPE_CAREGIVER = "caregiver";
export const ROLE_TYPE_ADMIN = "admin";
export const ROLE_TYPE_RESIDENT = "resident";
export const ROLE_TYPE_NURSE = "nurse";
export const ROLE_TYPE_FACILITY_ADMIN = "facility_admin";
export const ROLE_TYPE_FACILITY_WORKER = "facility_worker";
export const ROLE_TYPE_MHP = "mhp";
export const ROLE_TYPE_PROVIDER = "provider";
export const ROLE_TYPE_BUSINESS_VENDOR = "business_vendor";
export const ROLE_TYPE_RESIDENT_MANAGER = "resident_manager";
export const ROLE_TYPE_FAMILY_MEMBER = "family_member";

export const GROUP_NAME_AI_COMPANION_ADMIN = "AICompanionAdmin";
